import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { ToggleButton } from '@superops/ui-design-system';
import WarningModal from './WarningModal';
import { isEqual } from 'lodash';

const NULL_FIELDS_MAP = {
  mandatoryOnCreate: {
    RESOLUTION_CODE: 'resolutionCode',
    STATUS: 'status',
    TICKET_TYPE: 'ticketType'
  },
  mandatoryOnClosure: {
    STATUS: 'status',
    TICKET_TYPE: 'ticketType'
  },

  showToClient: {
    STATUS: 'status',
    IMPACT: 'impact',
    URGENCY: 'urgency',
    PRIORITY: 'priority',
    TICKET_TYPE: 'ticketType',
    CAUSE: 'cause',
    CATEGORY: 'category',
    RESOLUTION_CODE: 'resolutionCode'
  }
};

const ToggleCell = (props) => {
  const { cell } = props;

  const [modalActive, setModalActive] = useState(false);
  const updateField = cell?.column?.field?.action;
  const disableEdit =
    cell?.column?.field?.disableEdit ||
    cell?.row?.original?.status === 'INACTIVE';
  const key = cell?.column?.key;
  const data = cell?.row?.original;
  const columnName = data?.columnName;

  const getCellValue = () => {
    let value = null;
    const validationObject = NULL_FIELDS_MAP?.[key];
    if (
      validationObject &&
      Object.values(validationObject).includes(columnName)
    ) {
      value = null;
    } else {
      value = data?.[key];
    }
    return value;
  };

  const cellValue = getCellValue();

  const [value, setValue] = useState(cellValue);

  const onToggle = () => {
    setValue(!value);
    const updatedData = { id: data?.id, [key]: !value };
    updateField(updatedData);
  };

  useEffect(() => {
    if (!isEqual(cellValue, value)) {
      setValue(cellValue);
    }
  }, [cellValue, cell?.row]);

  return (
    <>
      <div className="flex actr jctr">
        {typeof value === 'boolean' ? (
          <>
            <ToggleButton
              onChange={onToggle}
              value={value}
              locked={disableEdit}
              size="small"
            />
          </>
        ) : (
          <>
            <div className="disabled-cell">
              <FormattedMessage id="app.noData.message" />
            </div>
          </>
        )}

        <WarningModal
          modalActive={modalActive}
          setModalActive={setModalActive}
          data={data}
          value={value}
          setValue={setValue}
          updateField={updateField}
        />
      </div>
    </>
  );
};

export default ToggleCell;
